enum BrokersActionsEnum {
    BrokersAdd = 'BROKERS/ADD',
    BrokersList = 'BROKERS/LIST',
    BrokersSet = 'BROKERS/SET',

    BrokersSearch = 'BROKERS/SEARCH',
    BrokersSearchResultsSet = 'BROKERS/SEARCH/RESULTS/SET',
    BrokersSearchResultsClear = 'BROKERS/SEARCH/RESULTS/CLEAR',

    BrokersHubspotErrorsList = 'BROKERS/HUBSPOT_ERRORS/LIST',
    BrokersHubspotErrorsSet = 'BROKERS/HUBSPOT_ERRORS/SET',

    BrokerHubspotErrorRetrySync = 'BROKER/HUBSPOT_ERROR/RETRY_SYNC',

    BrokerApprove = 'BROKER/APPROVE',
    BrokerAssignBdm = 'BROKER/ASSIGN_BDM',
    BrokerContactDate = 'BROKER/CONTACT_DATE',
    BrokerGet = 'BROKER/GET',
    BrokerRecordContact = 'BROKER/RECORD_CONTACT',
    BrokerReject = 'BROKER/REJECT',
    BrokerResetApprovalStatus = 'BROKER/RESET_APPROVAL_STATUS',
    BrokerSend = 'BROKER/SEND',
    BrokerSet = 'BROKER/SET',
    BrokerUnassignBdm = 'BROKER/UNASSIGN_BDM',
    BrokerEmail = 'BROKER/EMAIL',
    BrokerAfcaMembershipExpiryDate = 'BROKER/AFCA_MEMBERSHIP_EXPIRY_DATE',
    BrokerAsicSearchExpiryDate = 'BROKER/ASIC_SEARCH_EXPIRY_DATE',
    BrokerInsuranceExpiryDate = 'BROKER/INSURANCE_EXPIRY_DATE',
    BrokerMembershipExpiryDate = 'BROKER/MEMBERSHIP_EXPIRY_DATE',
    BrokerPhotoIdExpiryDate = 'BROKER/PHOTO_ID_EXPIRY_DATE',
    BrokerValueSet = 'BROKER/VALUE/SET',

    BrokerApplicationsList = 'BROKER/APPLICATIONS/LIST',
    BrokerApplicationsSet = 'BROKER/APPLICATIONS/SET',

    BrokerDocumentsList = 'BROKER/DOCUMENTS/LIST',
    BrokerDocumentsSet = 'BROKER/DOCUMENTS/SET',

    BrokerDocumentSet = 'BROKER/DOCUMENT/SET',
    BrokerDocumentUpload = 'BROKER/DOCUMENT/UPLOAD',

    BrokerHistoriesList = 'BROKER/HISTORIES/LIST',
    BrokerHistoriesSet = 'BROKER/HISTORIES/SET',

    BrokerDealsList = 'BROKER/DEALS/LIST',
    BrokerDealsSet = 'BROKER/DEALS/SET',

    BrokerNotesAdd = 'BROKER/NOTES/ADD',
    BrokerNotesList = 'BROKER/NOTES/LIST',
    BrokerNotesSet = 'BROKER/NOTES/SET',

    BrokerNoteRemove = 'BROKER/NOTE/REMOVE',
    BrokerNoteSet = 'BROKER/NOTE/SET',
}

export default BrokersActionsEnum;
